'use strict';

let TimeInterval=require('pulsar-utils/dist-es6/timeInterval');let

BaseZonedIntervalViewModel=class BaseZonedIntervalViewModel extends TimeInterval{
constructor(jsonInterval){
super(jsonInterval);
this._startTimezone=jsonInterval.startTimezone;
this._endTimezone=jsonInterval.endTimezone;
}

get startTimezone(){
return this._startTimezone;
}

get endTimezone(){
return this._endTimezone;
}};


module.exports=BaseZonedIntervalViewModel;
//# sourceMappingURL=baseZonedIntervalViewModel.js.map
